<template>
  <div>
    <button class="btn btn-outline-secondary btn-sm" @click="open = true" title="Ver os visuais equipados e onde comprá-los">
      <i class="fas fa-shirt"></i> Meus Visuais
    </button>

    <div v-if="open" class="mv-backdrop" @click.self="open = false">
      <div class="mv-panel" role="dialog" aria-modal="true" aria-label="Meus Visuais">
        <div class="mv-head">
          <strong>Meus Visuais</strong>
          <button class="btn-close btn-close-sm" aria-label="Fechar" @click="open = false"></button>
        </div>

        <ul class="mv-list">
          <li v-for="slot in slots" :key="slot.key" class="mv-row">
            <img v-if="slot.item.id" :src="itemIconUrl(slot.item.id)" class="mv-icon" alt="" @error="onIconError" />
            <span v-else class="mv-icon mv-icon-empty"></span>
            <span class="mv-text">
              <span class="mv-slot">{{ slot.label }}</span>
              <span class="mv-name" :class="{ 'mv-empty': !slot.item.id }">{{ slot.item.name || 'Vazio' }}</span>
            </span>
            <a v-if="slot.item.name"
               class="btn btn-sm btn-outline-primary mv-buy"
               :href="marketSearchUrl(slot.item.name, server)"
               target="_blank" rel="noopener noreferrer"
               :title="`Procurar &quot;${marketSearchTerm(slot.item.name)}&quot; no mercado de ${serverLabel[server]}`">
              <i class="fas fa-magnifying-glass"></i> Mercado
            </a>
          </li>
        </ul>

        <div v-if="hasAny" class="mv-server">
          <label for="mv-server-select" class="mv-server-label">Procurar no servidor</label>
          <select id="mv-server-select" class="form-select form-select-sm" v-model="server">
            <option v-for="s in servers" :key="s" :value="s">{{ serverLabel[s] }}</option>
          </select>
        </div>

        <p class="mv-note">
          <template v-if="hasAny">
            Os links abrem a <strong>Pesquisa de Mercado oficial</strong> do LatamRO, com os
            preços em tempo real. O MeuRag não guarda preços.
          </template>
          <template v-else>
            Equipe algum visual para ver aqui o que seu personagem está usando e procurar no mercado.
          </template>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { itemIconUrl } from '@/env';
import { MARKET_SERVERS, MARKET_SERVER_LABEL, marketSearchUrl, marketSearchTerm } from '@/services/market';

const SERVER_KEY = 'meurag:marketServer';

export default {
  name: 'EquippedPanel',
  data() {
    return {
      open: false,
      servers: MARKET_SERVERS,
      serverLabel: MARKET_SERVER_LABEL,
      // Remember the player's server so they don't reselect it every visit.
      server: MARKET_SERVERS.includes(localStorage.getItem(SERVER_KEY))
        ? localStorage.getItem(SERVER_KEY)
        : MARKET_SERVERS[0],
    };
  },
  computed: {
    slots() {
      const s = this.$store.state;
      return [
        { key: 'top', label: 'Topo', item: s.headgear_top_item || {} },
        { key: 'mid', label: 'Meio', item: s.headgear_mid_item || {} },
        { key: 'bot', label: 'Baixo', item: s.headgear_bottom_item || {} },
        { key: 'garment', label: 'Capa', item: s.garment_item || {} },
      ];
    },
    hasAny() {
      return this.slots.some((s) => s.item && s.item.name);
    },
  },
  watch: {
    server(v) {
      localStorage.setItem(SERVER_KEY, v);
    },
  },
  methods: {
    itemIconUrl,
    marketSearchUrl,
    marketSearchTerm,
    onIconError(e) {
      if (e && e.target) e.target.src = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
    },
  },
};
</script>

<style scoped>
.mv-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1080;
  padding: 12px;
}
.mv-panel {
  background: #fff;
  border-radius: 8px;
  width: 100%;
  max-width: 380px;
  max-height: 85vh;
  overflow-y: auto;
  padding: 12px 14px 14px;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.25);
  text-align: left;
}
.mv-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.mv-list {
  list-style: none;
  padding: 0;
  margin: 0 0 10px;
}
.mv-row {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 0;
  border-bottom: 1px solid #f1f1f1;
}
.mv-row:last-child {
  border-bottom: 0;
}
.mv-icon {
  width: 28px;
  height: 28px;
  object-fit: contain;
  flex: 0 0 28px;
}
.mv-icon-empty {
  border: 1px dashed #dcdcdc;
  border-radius: 4px;
}
.mv-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1 1 auto;
}
.mv-slot {
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  color: #8a8a8a;
}
.mv-name {
  font-size: 0.84rem;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.mv-empty {
  color: #b0b0b0;
  font-style: italic;
}
.mv-buy {
  flex: 0 0 auto;
  white-space: nowrap;
}
.mv-server {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}
.mv-server-label {
  font-size: 0.78rem;
  color: #555;
  white-space: nowrap;
  margin: 0;
}
.mv-note {
  font-size: 0.72rem;
  color: #6c757d;
  margin: 0;
  line-height: 1.35;
}
</style>
